
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequirefc28"];
var parcelRegister = parcelRequire.register;
parcelRegister("iPR6g", function(module, exports) {
$parcel$export(module.exports, "editorCommandToPMCommand", () => $6619fdb6ae051335$export$bd352a83a17b2af8);

var $8O4hA = parcelRequire("8O4hA");
function $6619fdb6ae051335$export$bd352a83a17b2af8(command) {
    return ({ tr: tr }, dispatch)=>{
        const newTr = command === null || command === void 0 ? void 0 : command({
            tr: tr
        });
        if (!newTr) return false;
        if (newTr instanceof (0, $8O4hA.PassiveTransaction)) return true;
        dispatch === null || dispatch === void 0 || dispatch(newTr);
        return true;
    };
}

});
parcelRegister("8O4hA", function(module, exports) {
$parcel$export(module.exports, "PassiveTransaction", () => $08b1be1f1fd7d375$export$95069e054e554fa9);

var $cw0wu = parcelRequire("cw0wu");
class $08b1be1f1fd7d375$export$95069e054e554fa9 extends (0, $cw0wu.Transaction) {
    // This is very cheeky but this should never be used outside its intended
    // purpose - it will likely crash the editor so we should get an early warning
    // signal
    constructor(){
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        super({});
    }
}

});


parcelRegister("cv8id", function(module, exports) {
$parcel$export(module.exports, "addAltText", () => $9d680eb148465d1f$export$82527b23b485fa7f);
$parcel$export(module.exports, "makeKeyMapWithCommon", () => $9d680eb148465d1f$export$7e6b588cc98b34f1);
$parcel$export(module.exports, "navToEditorToolbar", () => $9d680eb148465d1f$export$9288bbefb6b7498b);
$parcel$export(module.exports, "navToFloatingToolbar", () => $9d680eb148465d1f$export$7be006a99a30f86b);
$parcel$export(module.exports, "askAIQuickInsert", () => $9d680eb148465d1f$export$ae37214e128d9cc3);
$parcel$export(module.exports, "toggleBold", () => $9d680eb148465d1f$export$183fe6d20e9e58ba);
$parcel$export(module.exports, "toggleItalic", () => $9d680eb148465d1f$export$b03177f345903916);
$parcel$export(module.exports, "toggleUnderline", () => $9d680eb148465d1f$export$6bcc93697958b66d);
$parcel$export(module.exports, "toggleStrikethrough", () => $9d680eb148465d1f$export$6d564ba4eaf138d9);
$parcel$export(module.exports, "toggleSubscript", () => $9d680eb148465d1f$export$d26ab98fee0c804);
$parcel$export(module.exports, "toggleSuperscript", () => $9d680eb148465d1f$export$4af6b58e12324fd);
$parcel$export(module.exports, "toggleCode", () => $9d680eb148465d1f$export$70686c6e7e15ed46);
$parcel$export(module.exports, "pastePlainText", () => $9d680eb148465d1f$export$ab06dc742bb20e03);
$parcel$export(module.exports, "clearFormatting", () => $9d680eb148465d1f$export$195de5d8e201efd7);
$parcel$export(module.exports, "setNormalText", () => $9d680eb148465d1f$export$63c4f0859cc75dc6);
$parcel$export(module.exports, "toggleHeading1", () => $9d680eb148465d1f$export$953ab0e6a5d310a9);
$parcel$export(module.exports, "toggleHeading2", () => $9d680eb148465d1f$export$192a351cfd6ca247);
$parcel$export(module.exports, "toggleHeading3", () => $9d680eb148465d1f$export$fe382f3f4c871c62);
$parcel$export(module.exports, "toggleHeading4", () => $9d680eb148465d1f$export$4073e08db19e0e31);
$parcel$export(module.exports, "toggleHeading5", () => $9d680eb148465d1f$export$b84e85b2035ddb39);
$parcel$export(module.exports, "toggleHeading6", () => $9d680eb148465d1f$export$86b1ac99fd15509b);
$parcel$export(module.exports, "toggleSmallText", () => $9d680eb148465d1f$export$16f43eb2b2380de5);
$parcel$export(module.exports, "toggleOrderedList", () => $9d680eb148465d1f$export$dca848a1b50b6a31);
$parcel$export(module.exports, "toggleBulletList", () => $9d680eb148465d1f$export$c0e115f47553645e);
$parcel$export(module.exports, "toggleBlockQuote", () => $9d680eb148465d1f$export$34ed0cbd4f7ff88);
$parcel$export(module.exports, "insertNewLine", () => $9d680eb148465d1f$export$c2d9390f63354627);
$parcel$export(module.exports, "insertRule", () => $9d680eb148465d1f$export$5f13bbad564673d4);
$parcel$export(module.exports, "undo", () => $9d680eb148465d1f$export$21f930c44940fd98);
$parcel$export(module.exports, "moveUp", () => $9d680eb148465d1f$export$44935f8a884b57b9);
$parcel$export(module.exports, "moveDown", () => $9d680eb148465d1f$export$8eba228b343b3599);
$parcel$export(module.exports, "moveLeft", () => $9d680eb148465d1f$export$108f27160c89e515);
$parcel$export(module.exports, "moveRight", () => $9d680eb148465d1f$export$e2c874fbfec7201);
$parcel$export(module.exports, "indentList", () => $9d680eb148465d1f$export$8066a906978eedb2);
$parcel$export(module.exports, "outdentList", () => $9d680eb148465d1f$export$959569198ddbbe17);
$parcel$export(module.exports, "redoAlt", () => $9d680eb148465d1f$export$c0e41ad67d77f6bb);
$parcel$export(module.exports, "redo", () => $9d680eb148465d1f$export$1688e416fee0a49e);
$parcel$export(module.exports, "openHelp", () => $9d680eb148465d1f$export$1e2fd7795238a2d3);
$parcel$export(module.exports, "addLink", () => $9d680eb148465d1f$export$56b88caa6d8a3bff);
$parcel$export(module.exports, "addInlineComment", () => $9d680eb148465d1f$export$fd78ad47ea0892f4);
$parcel$export(module.exports, "copyLinkToBlock", () => $9d680eb148465d1f$export$278533b7b7607665);
$parcel$export(module.exports, "submit", () => $9d680eb148465d1f$export$853c27de4ce0f746);
$parcel$export(module.exports, "enter", () => $9d680eb148465d1f$export$e668df1bcd81e4d2);
$parcel$export(module.exports, "tab", () => $9d680eb148465d1f$export$62d58b1c91e8e902);
$parcel$export(module.exports, "indent", () => $9d680eb148465d1f$export$79ebfa808dffa5c6);
$parcel$export(module.exports, "outdent", () => $9d680eb148465d1f$export$25755c0352544598);
$parcel$export(module.exports, "backspace", () => $9d680eb148465d1f$export$1ea584ca7009bcc1);
$parcel$export(module.exports, "deleteKey", () => $9d680eb148465d1f$export$9603e93cdf38d7);
$parcel$export(module.exports, "forwardDelete", () => $9d680eb148465d1f$export$9e41eded5cb7e706);
$parcel$export(module.exports, "escape", () => $9d680eb148465d1f$export$4e7f196112fea3c5);
$parcel$export(module.exports, "nextCell", () => $9d680eb148465d1f$export$172699367bb25225);
$parcel$export(module.exports, "previousCell", () => $9d680eb148465d1f$export$69838570e03d7193);
$parcel$export(module.exports, "shiftArrowUp", () => $9d680eb148465d1f$export$776c0cd47234205a);
$parcel$export(module.exports, "shiftTab", () => $9d680eb148465d1f$export$9ad63694f5781e16);
$parcel$export(module.exports, "toggleTable", () => $9d680eb148465d1f$export$33b9473b3f67763f);
$parcel$export(module.exports, "focusTableResizer", () => $9d680eb148465d1f$export$a57fbe0d9c764ae0);
$parcel$export(module.exports, "addRowBefore", () => $9d680eb148465d1f$export$2e3087448cf87857);
$parcel$export(module.exports, "addRowAfter", () => $9d680eb148465d1f$export$fbcf51cabbe4a007);
$parcel$export(module.exports, "addColumnAfter", () => $9d680eb148465d1f$export$bf95f7b7d259c19f);
$parcel$export(module.exports, "addColumnBefore", () => $9d680eb148465d1f$export$717d5ccb817cdecc);
$parcel$export(module.exports, "addRowBeforeVO", () => $9d680eb148465d1f$export$5851c701392d3bfd);
$parcel$export(module.exports, "addRowAfterVO", () => $9d680eb148465d1f$export$73fa63faf0fd6077);
$parcel$export(module.exports, "addColumnAfterVO", () => $9d680eb148465d1f$export$875b853996fced8d);
$parcel$export(module.exports, "addColumnBeforeVO", () => $9d680eb148465d1f$export$414418ca306c22bd);
$parcel$export(module.exports, "moveColumnLeftOld", () => $9d680eb148465d1f$export$a055d05df46abae5);
$parcel$export(module.exports, "moveColumnLeft", () => $9d680eb148465d1f$export$f092689a35ce978d);
$parcel$export(module.exports, "moveColumnRightOld", () => $9d680eb148465d1f$export$7ff94d9a4edfc7f);
$parcel$export(module.exports, "moveColumnRight", () => $9d680eb148465d1f$export$863ee96d9e15383b);
$parcel$export(module.exports, "moveRowDownOld", () => $9d680eb148465d1f$export$180b7d3240961d01);
$parcel$export(module.exports, "moveRowDown", () => $9d680eb148465d1f$export$13c2dd2d968ada2a);
$parcel$export(module.exports, "moveRowUpOld", () => $9d680eb148465d1f$export$88de3148cc9ddd81);
$parcel$export(module.exports, "moveRowUp", () => $9d680eb148465d1f$export$e6749a6fc243b921);
$parcel$export(module.exports, "deleteColumn", () => $9d680eb148465d1f$export$f4f2d7d33085c714);
$parcel$export(module.exports, "deleteRow", () => $9d680eb148465d1f$export$2ef39e5ffdaff9ed);
$parcel$export(module.exports, "startColumnResizing", () => $9d680eb148465d1f$export$8f58457f1327dd26);
$parcel$export(module.exports, "find", () => $9d680eb148465d1f$export$71aa6c912b956294);
$parcel$export(module.exports, "alignLeft", () => $9d680eb148465d1f$export$ca42dd9a1a0eb501);
$parcel$export(module.exports, "alignCenter", () => $9d680eb148465d1f$export$f4a51ff076cc9a09);
$parcel$export(module.exports, "alignRight", () => $9d680eb148465d1f$export$faf8793e4a37a5a2);
$parcel$export(module.exports, "toggleTaskItemCheckbox", () => $9d680eb148465d1f$export$6f041e7a1d88fa51);
$parcel$export(module.exports, "toggleTaskList", () => $9d680eb148465d1f$export$2e48e3ea1c210731);
$parcel$export(module.exports, "selectRow", () => $9d680eb148465d1f$export$e247ed8cec4832f4);
$parcel$export(module.exports, "selectColumn", () => $9d680eb148465d1f$export$c2e8772deb1607ea);
$parcel$export(module.exports, "selectTable", () => $9d680eb148465d1f$export$625c5b9bf13f01a8);
$parcel$export(module.exports, "increaseMediaSize", () => $9d680eb148465d1f$export$fdeca4160ac263c5);
$parcel$export(module.exports, "decreaseMediaSize", () => $9d680eb148465d1f$export$5ec5f857fec297eb);
$parcel$export(module.exports, "activateVideoControls", () => $9d680eb148465d1f$export$36141559a83247ee);
$parcel$export(module.exports, "toggleHighlightPalette", () => $9d680eb148465d1f$export$ec123199f2fe4770);
$parcel$export(module.exports, "applyYellowHighlight", () => $9d680eb148465d1f$export$62f87f0ca411e518);
$parcel$export(module.exports, "focusToContextMenuTrigger", () => $9d680eb148465d1f$export$6b05735f625d1c82);
$parcel$export(module.exports, "dragToMoveUp", () => $9d680eb148465d1f$export$a1bdda43619f945f);
$parcel$export(module.exports, "dragToMoveDown", () => $9d680eb148465d1f$export$9bf312985dc8137e);
$parcel$export(module.exports, "dragToMoveLeft", () => $9d680eb148465d1f$export$c4f661b85fc92fd1);
$parcel$export(module.exports, "dragToMoveRight", () => $9d680eb148465d1f$export$61c867f4a21787f6);
$parcel$export(module.exports, "showElementDragHandle", () => $9d680eb148465d1f$export$ba34d2a4e6aa10e4);
$parcel$export(module.exports, "toggleCodeBlock", () => $9d680eb148465d1f$export$e9c6aab026be9523);
$parcel$export(module.exports, "insertEmoji", () => $9d680eb148465d1f$export$8d5c072327044b6f);
$parcel$export(module.exports, "insertMention", () => $9d680eb148465d1f$export$8c4314a90d4c5fc1);
$parcel$export(module.exports, "insertTaskList", () => $9d680eb148465d1f$export$cf3c284f81e5d477);
$parcel$export(module.exports, "insertElements", () => $9d680eb148465d1f$export$edd9d3cec5b0a9b6);
$parcel$export(module.exports, "formatShortcut", () => $9d680eb148465d1f$export$384a290f8c265cc5);
$parcel$export(module.exports, "tooltip", () => $9d680eb148465d1f$export$4e6f96734dfe12f4);
$parcel$export(module.exports, "ToolTipContent", () => $9d680eb148465d1f$export$4096cb8ab9668358);
$parcel$export(module.exports, "TooltipContentWithMultipleShortcuts", () => $9d680eb148465d1f$export$9f7e5fe6d45c5f7);
$parcel$export(module.exports, "findKeymapByDescription", () => $9d680eb148465d1f$export$c4e6735ce96cc7b3);
$parcel$export(module.exports, "findShortcutByKeymap", () => $9d680eb148465d1f$export$d69faf3b7bc3451);
$parcel$export(module.exports, "getAriaKeyshortcuts", () => $9d680eb148465d1f$export$6db28e5c399297b0);
$parcel$export(module.exports, "bindKeymapWithCommand", () => $9d680eb148465d1f$export$4bced0ac29aaf950);
$parcel$export(module.exports, "bindKeymapArrayWithCommand", () => $9d680eb148465d1f$export$e40cfdbcfa26f180);
$parcel$export(module.exports, "bindKeymapWithEditorCommand", () => $9d680eb148465d1f$export$b87d3e1cb85f0ba1);
$parcel$export(module.exports, "findKeyMapForBrowser", () => $9d680eb148465d1f$export$b2dbe47650bcfa54);
$parcel$export(module.exports, "isCapsLockOnAndModifyKeyboardEvent", () => $9d680eb148465d1f$export$f2da701c7659a26c);
/* eslint-disable @atlaskit/volt-strict-mode/no-multiple-exports */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $bSJIT = parcelRequire("bSJIT");

var $9dQre = parcelRequire("9dQre");

var $kitud = parcelRequire("kitud");

var $iPR6g = parcelRequire("iPR6g");

var $jxkn6 = parcelRequire("jxkn6");


// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $9d680eb148465d1f$var$MOD_REGEX = /Mod/i;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $9d680eb148465d1f$var$CMD_REGEX = /Cmd/i;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $9d680eb148465d1f$var$SHIFT_REGEX = /Shift/i;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $9d680eb148465d1f$var$CTRL_REGEX = /Ctrl/i;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $9d680eb148465d1f$var$ALT_REGEX = /Alt/i;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $9d680eb148465d1f$var$BACKSPACE_REGEX = /Backspace/i;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $9d680eb148465d1f$var$ENTER_REGEX = /Enter/i;
// Ignored via go/ees005
// eslint-disable-next-line require-unicode-regexp
const $9d680eb148465d1f$var$UPPERCASE_START_REGEX = /^[A-Z]/;
const $9d680eb148465d1f$export$82527b23b485fa7f = $9d680eb148465d1f$export$7e6b588cc98b34f1('Add Alt Text', 'Mod-Alt-y');
const $9d680eb148465d1f$export$c515872d50566e7b = $9d680eb148465d1f$export$7e6b588cc98b34f1('Toggle markdown view', 'Mod-e');
const $9d680eb148465d1f$export$22d712d636967812 = $9d680eb148465d1f$export$7e6b588cc98b34f1('View changes', 'Mod-Alt-z');
const $9d680eb148465d1f$export$9288bbefb6b7498b = $9d680eb148465d1f$export$7e6b588cc98b34f1('Navigate to editor toolbar', 'Alt-F9');
const $9d680eb148465d1f$export$7be006a99a30f86b = $9d680eb148465d1f$export$7e6b588cc98b34f1('Navigate to floating toolbar', 'Alt-F10');
const $9d680eb148465d1f$export$ae37214e128d9cc3 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Ask AI', "Mod-'");
const $9d680eb148465d1f$export$183fe6d20e9e58ba = $9d680eb148465d1f$export$7e6b588cc98b34f1('Bold', 'Mod-b');
const $9d680eb148465d1f$export$b03177f345903916 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Italic', 'Mod-i');
const $9d680eb148465d1f$export$6bcc93697958b66d = $9d680eb148465d1f$export$7e6b588cc98b34f1('Underline', 'Mod-u');
const $9d680eb148465d1f$export$6d564ba4eaf138d9 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Strikethrough', 'Mod-Shift-s');
const $9d680eb148465d1f$export$d26ab98fee0c804 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Subscript', 'Mod-Shift-,');
const $9d680eb148465d1f$export$4af6b58e12324fd = $9d680eb148465d1f$export$7e6b588cc98b34f1('Superscript', 'Mod-Shift-.');
const $9d680eb148465d1f$export$70686c6e7e15ed46 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Code', 'Mod-Shift-m');
const $9d680eb148465d1f$export$ab06dc742bb20e03 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Paste Plain Text', 'Mod-Shift-v');
const $9d680eb148465d1f$export$195de5d8e201efd7 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Clear formatting', 'Mod-\\');
const $9d680eb148465d1f$export$63c4f0859cc75dc6 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Normal text', 'Mod-Alt-0');
const $9d680eb148465d1f$export$953ab0e6a5d310a9 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Heading 1', 'Mod-Alt-1');
const $9d680eb148465d1f$export$192a351cfd6ca247 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Heading 2', 'Mod-Alt-2');
const $9d680eb148465d1f$export$fe382f3f4c871c62 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Heading 3', 'Mod-Alt-3');
const $9d680eb148465d1f$export$4073e08db19e0e31 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Heading 4', 'Mod-Alt-4');
const $9d680eb148465d1f$export$b84e85b2035ddb39 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Heading 5', 'Mod-Alt-5');
const $9d680eb148465d1f$export$86b1ac99fd15509b = $9d680eb148465d1f$export$7e6b588cc98b34f1('Heading 6', 'Mod-Alt-6');
const $9d680eb148465d1f$export$16f43eb2b2380de5 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Small text', 'Mod-Alt-7');
const $9d680eb148465d1f$export$dca848a1b50b6a31 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Numbered list', 'Mod-Shift-7');
const $9d680eb148465d1f$export$17f69a767ce93bb3 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Cmd + Backspace', 'Mod-Backspace');
const $9d680eb148465d1f$export$c0e115f47553645e = $9d680eb148465d1f$export$7e6b588cc98b34f1('Bullet list', 'Mod-Shift-8');
const $9d680eb148465d1f$export$34ed0cbd4f7ff88 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Quote', 'Mod-Shift-9');
const $9d680eb148465d1f$export$c2d9390f63354627 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Insert new line', 'Shift-Enter');
const $9d680eb148465d1f$export$dfd73a1c108b1570 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Shift Backspace', 'Shift-Backspace');
const $9d680eb148465d1f$export$9e5a9569a07601f2 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Split code block', 'Enter');
const $9d680eb148465d1f$export$e920ee2eb756d384 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Split list item', 'Enter');
const $9d680eb148465d1f$export$5f13bbad564673d4 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Insert horizontal rule', 'Mod-Shift--');
const $9d680eb148465d1f$export$21f930c44940fd98 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Undo', 'Mod-z');
const $9d680eb148465d1f$export$44935f8a884b57b9 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Move up', 'ArrowUp');
const $9d680eb148465d1f$export$8eba228b343b3599 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Move down', 'ArrowDown');
const $9d680eb148465d1f$export$108f27160c89e515 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Move left', 'ArrowLeft');
const $9d680eb148465d1f$export$e2c874fbfec7201 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Move right', 'ArrowRight');
const $9d680eb148465d1f$export$8066a906978eedb2 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Indent List', 'Tab');
const $9d680eb148465d1f$export$959569198ddbbe17 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Outdent List', 'Shift-Tab');
const $9d680eb148465d1f$export$c0e41ad67d77f6bb = $9d680eb148465d1f$export$7e6b588cc98b34f1('Redo', 'Mod-y');
const $9d680eb148465d1f$export$1688e416fee0a49e = $9d680eb148465d1f$export$d8a7f422d8d42038('Redo', 'Ctrl-y', 'Mod-Shift-z');
const $9d680eb148465d1f$export$1e2fd7795238a2d3 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Open Help', 'Mod-/');
const $9d680eb148465d1f$export$56b88caa6d8a3bff = $9d680eb148465d1f$export$7e6b588cc98b34f1('Link', 'Mod-k');
const $9d680eb148465d1f$export$fd78ad47ea0892f4 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Annotate', 'Mod-Alt-c');
const $9d680eb148465d1f$export$278533b7b7607665 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Copy link to selection', 'Mod-Alt-a');
const $9d680eb148465d1f$export$853c27de4ce0f746 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Submit Content', 'Mod-Enter');
const $9d680eb148465d1f$export$e668df1bcd81e4d2 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Enter', 'Enter');
const $9d680eb148465d1f$export$9f99fe2ed5bb7a29 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Shift Enter', 'Shift-Enter');
const $9d680eb148465d1f$export$62d58b1c91e8e902 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Tab', 'Tab');
const $9d680eb148465d1f$export$79ebfa808dffa5c6 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Indent', 'Tab');
const $9d680eb148465d1f$export$25755c0352544598 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Outdent', 'Shift-Tab');
const $9d680eb148465d1f$export$1ea584ca7009bcc1 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Backspace', 'Backspace');
const $9d680eb148465d1f$export$9603e93cdf38d7 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Delete', 'Delete');
const $9d680eb148465d1f$export$9e41eded5cb7e706 = $9d680eb148465d1f$export$d8a7f422d8d42038('Forward Delete', '', 'Ctrl-d');
const $9d680eb148465d1f$export$a941ed4b947d12f8 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Space', 'Space');
const $9d680eb148465d1f$export$4e7f196112fea3c5 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Escape', 'Escape');
const $9d680eb148465d1f$export$172699367bb25225 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Next cell', 'Tab');
const $9d680eb148465d1f$export$69838570e03d7193 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Previous cell', 'Shift-Tab');
const $9d680eb148465d1f$export$776c0cd47234205a = $9d680eb148465d1f$export$7e6b588cc98b34f1('Shift ArrowUp', 'Shift-ArrowUp');
const $9d680eb148465d1f$export$9ad63694f5781e16 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Shift Tab', 'Shift-Tab');
const $9d680eb148465d1f$export$33b9473b3f67763f = $9d680eb148465d1f$export$7e6b588cc98b34f1('Table', 'Shift-Alt-t');
const $9d680eb148465d1f$export$a57fbe0d9c764ae0 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Focus Table Resizer', 'Mod-Alt-Shift-r');
const $9d680eb148465d1f$export$2e3087448cf87857 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Add Row Above', 'Ctrl-Alt-ArrowUp');
const $9d680eb148465d1f$export$fbcf51cabbe4a007 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Add Row Below', 'Ctrl-Alt-ArrowDown');
const $9d680eb148465d1f$export$bf95f7b7d259c19f = $9d680eb148465d1f$export$7e6b588cc98b34f1('Add Column After', 'Ctrl-Alt-ArrowRight');
const $9d680eb148465d1f$export$717d5ccb817cdecc = $9d680eb148465d1f$export$7e6b588cc98b34f1('Add Column Before', 'Ctrl-Alt-ArrowLeft');
const $9d680eb148465d1f$export$5851c701392d3bfd = $9d680eb148465d1f$export$7e6b588cc98b34f1('Add Row Above', 'Mod-Alt-[');
const $9d680eb148465d1f$export$73fa63faf0fd6077 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Add Row Below', 'Mod-Alt-]');
const $9d680eb148465d1f$export$875b853996fced8d = $9d680eb148465d1f$export$7e6b588cc98b34f1('Add Column After', 'Mod-Alt-=');
const $9d680eb148465d1f$export$414418ca306c22bd = $9d680eb148465d1f$export$7e6b588cc98b34f1('Add Column Before', 'Mod-Alt--');
const $9d680eb148465d1f$export$a055d05df46abae5 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Move Column Left', 'Ctrl-Alt-Shift-ArrowLeft');
const $9d680eb148465d1f$export$f092689a35ce978d = $9d680eb148465d1f$export$7e6b588cc98b34f1('Move Column Left', 'Mod-Alt-Shift--');
const $9d680eb148465d1f$export$7ff94d9a4edfc7f = $9d680eb148465d1f$export$7e6b588cc98b34f1('Move Column Right', 'Ctrl-Alt-Shift-ArrowRight');
const $9d680eb148465d1f$export$863ee96d9e15383b = $9d680eb148465d1f$export$7e6b588cc98b34f1('Move Column Right', 'Mod-Alt-Shift-=');
const $9d680eb148465d1f$export$180b7d3240961d01 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Move Row Down', 'Ctrl-Alt-Shift-ArrowDown');
const $9d680eb148465d1f$export$13c2dd2d968ada2a = $9d680eb148465d1f$export$7e6b588cc98b34f1('Move Row Down', 'Mod-Alt-Shift-]');
const $9d680eb148465d1f$export$88de3148cc9ddd81 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Move Row Up', 'Ctrl-Alt-Shift-ArrowUp');
const $9d680eb148465d1f$export$e6749a6fc243b921 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Move Row Up', 'Mod-Alt-Shift-[');
const $9d680eb148465d1f$export$f4f2d7d33085c714 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Delete Column', 'Ctrl-Backspace');
const $9d680eb148465d1f$export$2ef39e5ffdaff9ed = $9d680eb148465d1f$export$7e6b588cc98b34f1('Delete Row', 'Ctrl-Backspace');
const $9d680eb148465d1f$export$8f58457f1327dd26 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Activate Column Resize', 'Mod-Alt-Shift-c');
const $9d680eb148465d1f$export$af2a99f971a346e6 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Cut', 'Mod-x');
const $9d680eb148465d1f$export$784d13d8ee351f07 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Copy', 'Mod-c');
const $9d680eb148465d1f$export$9b6706c8686cfc8e = $9d680eb148465d1f$export$7e6b588cc98b34f1('Paste', 'Mod-v');
const $9d680eb148465d1f$export$3c1455b21d3e7aab = $9d680eb148465d1f$export$7e6b588cc98b34f1('Paste', 'Mod-Shift-v');
const $9d680eb148465d1f$export$71aa6c912b956294 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Find', 'Mod-f');
const $9d680eb148465d1f$export$ca42dd9a1a0eb501 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Align Left', 'Mod-Shift-l');
const $9d680eb148465d1f$export$f4a51ff076cc9a09 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Align Center', 'Mod-Alt-e');
const $9d680eb148465d1f$export$faf8793e4a37a5a2 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Align Right', 'Mod-Alt-t');
const $9d680eb148465d1f$export$6f041e7a1d88fa51 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Toggles task item', 'Mod-Alt-Enter');
const $9d680eb148465d1f$export$2e48e3ea1c210731 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Toggle task list', 'Mod-Shift-6');
const $9d680eb148465d1f$export$e247ed8cec4832f4 = $9d680eb148465d1f$export$5882c1dfa05eb556('Select row', [
    'Mod-Alt-Shift-ArrowLeft',
    'Mod-Alt-Shift-ArrowRight'
]);
const $9d680eb148465d1f$export$c2e8772deb1607ea = $9d680eb148465d1f$export$5882c1dfa05eb556('Select column', [
    'Mod-Alt-Shift-ArrowDown',
    'Mod-Alt-Shift-ArrowUp'
]);
const $9d680eb148465d1f$export$625c5b9bf13f01a8 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Select table', 'Mod-a');
const $9d680eb148465d1f$export$fdeca4160ac263c5 = $9d680eb148465d1f$export$7e6b588cc98b34f1('increase image size', 'Mod-Alt-]');
const $9d680eb148465d1f$export$5ec5f857fec297eb = $9d680eb148465d1f$export$7e6b588cc98b34f1('increase image size', 'Mod-Alt-[');
const $9d680eb148465d1f$export$36141559a83247ee = $9d680eb148465d1f$export$7e6b588cc98b34f1('Activate controls panel on video', 'Shift-F10');
const $9d680eb148465d1f$export$ec123199f2fe4770 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Toggle Highlight Palette', 'Mod-Alt-b');
const $9d680eb148465d1f$export$62f87f0ca411e518 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Apply Yellow Highlight', 'Mod-Alt-y');
const $9d680eb148465d1f$export$6b05735f625d1c82 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Focus table context menu trigger', 'Shift-F10');
const $9d680eb148465d1f$export$a1bdda43619f945f = $9d680eb148465d1f$export$7e6b588cc98b34f1('Move node up in the document', 'Ctrl-Shift-ArrowUp');
const $9d680eb148465d1f$export$9bf312985dc8137e = $9d680eb148465d1f$export$7e6b588cc98b34f1('Move node down in the document', 'Ctrl-Shift-ArrowDown');
const $9d680eb148465d1f$export$c4f661b85fc92fd1 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Move node to the left column in the document', 'Ctrl-Shift-Alt-ArrowLeft');
const $9d680eb148465d1f$export$61c867f4a21787f6 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Move node to the right column in the document', 'Ctrl-Shift-Alt-ArrowRight');
const $9d680eb148465d1f$export$ba34d2a4e6aa10e4 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Show drag handle for editor element', 'Ctrl-Shift-h');
const $9d680eb148465d1f$export$e9c6aab026be9523 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Toggle Code Block', '```');
const $9d680eb148465d1f$export$8d5c072327044b6f = $9d680eb148465d1f$export$7e6b588cc98b34f1('Insert Emoji', ':');
const $9d680eb148465d1f$export$8c4314a90d4c5fc1 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Insert Mention', '@');
const $9d680eb148465d1f$export$cf3c284f81e5d477 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Insert Action Item', '[]');
const $9d680eb148465d1f$export$edd9d3cec5b0a9b6 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Insert Elements', '/');
const $9d680eb148465d1f$export$54f122e0d55178a9 = $9d680eb148465d1f$export$7e6b588cc98b34f1('Continue in Rovo chat', 'Alt-Enter');
const $9d680eb148465d1f$var$arrowKeysMap = {
    // for reference: https://wincent.com/wiki/Unicode_representations_of_modifier_keys
    ARROWLEFT: '\u2190',
    ARROWRIGHT: '\u2192',
    ARROWUP: '\u2191',
    ARROWDOWN: '\u2193'
};
const $9d680eb148465d1f$var$tooltipShortcutStyle = /*#__PURE__*/ (0, $9dQre.css)({
    borderRadius: "var(--ds-radius-xsmall, 2px)",
    backgroundColor: "var(--ds-background-inverse-subtle, #00000029)",
    padding: `0 ${"var(--ds-space-025, 2px)"}`,
    // NOTE: This might not actually do anything: https://atlassian.slack.com/archives/CFG3PSQ9E/p1647395052443259?thread_ts=1647394572.556029&cid=CFG3PSQ9E
    label: 'tooltip-shortcut'
});
function $9d680eb148465d1f$export$384a290f8c265cc5(keymap) {
    let shortcut;
    const browser = (0, $jxkn6.getBrowserInfo)();
    if (browser.mac) // for reference: https://wincent.com/wiki/Unicode_representations_of_modifier_keys
    shortcut = keymap.mac.replace($9d680eb148465d1f$var$CMD_REGEX, '\u2318').replace($9d680eb148465d1f$var$SHIFT_REGEX, '\u21E7').replace($9d680eb148465d1f$var$CTRL_REGEX, '\u2303').replace($9d680eb148465d1f$var$ALT_REGEX, '\u2325').replace($9d680eb148465d1f$var$BACKSPACE_REGEX, '\u232B').replace($9d680eb148465d1f$var$ENTER_REGEX, '\u23CE');
    else shortcut = keymap.windows.replace($9d680eb148465d1f$var$BACKSPACE_REGEX, '\u232B');
    // If there are two - keys side by side preserve it's place so we can add it back
    const keys = shortcut.split('-');
    let storedEnDash = false;
    if (keys[keys.length - 1] === '' && keys[keys.length - 2] === '') storedEnDash = true;
    let lastKey = keys[keys.length - 1];
    if (lastKey.length === 1) // capitalise single letters
    lastKey = lastKey.toUpperCase();
    keys[keys.length - 1] = $9d680eb148465d1f$var$arrowKeysMap[lastKey.toUpperCase()] || lastKey;
    if (storedEnDash) keys[keys.length - 1] = '-';
    return keys.join(browser.mac ? '' : '+');
}
function $9d680eb148465d1f$export$4e6f96734dfe12f4(keymap, description) {
    if (keymap) {
        const shortcut = $9d680eb148465d1f$export$384a290f8c265cc5(keymap);
        return description ? `${description} ${shortcut}` : shortcut;
    }
    return;
}
const $9d680eb148465d1f$export$4096cb8ab9668358 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).memo(({ description: description, shortcutOverride: shortcutOverride, keymap: keymap })=>{
    const shortcut = shortcutOverride || keymap && $9d680eb148465d1f$export$384a290f8c265cc5(keymap);
    return shortcut || description ? /*#__PURE__*/ (0, $9dQre.jsx)((0, $bSJIT.Fragment), null, description, shortcut && description && '\u00A0', shortcut && /*#__PURE__*/ (0, $9dQre.jsx)("span", {
        css: $9d680eb148465d1f$var$tooltipShortcutStyle
    }, shortcut)) : null;
});
const $9d680eb148465d1f$export$9f7e5fe6d45c5f7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($bSJIT))).memo(({ helpDescriptors: helpDescriptors })=>{
    const keymapCount = helpDescriptors.length;
    return /*#__PURE__*/ (0, $9dQre.jsx)((0, $bSJIT.Fragment), null, helpDescriptors.map((descriptor, index)=>// Ignored via go/ees005
        // eslint-disable-next-line react/no-array-index-key
        /*#__PURE__*/ (0, $9dQre.jsx)((0, $bSJIT.Fragment), {
            key: index
        }, /*#__PURE__*/ (0, $9dQre.jsx)($9d680eb148465d1f$export$4096cb8ab9668358, descriptor), ' ', index < keymapCount - 1 && /*#__PURE__*/ (0, $9dQre.jsx)("br", null))));
});
function $9d680eb148465d1f$export$c4e6735ce96cc7b3(description) {
    const matches = $9d680eb148465d1f$var$ALL.filter((keymap)=>keymap.description.toUpperCase() === description.toUpperCase());
    return matches[0];
}
function $9d680eb148465d1f$export$ca66063a345ce3ab(description) {
    const keymap = $9d680eb148465d1f$export$c4e6735ce96cc7b3(description);
    if (keymap) return $9d680eb148465d1f$export$d69faf3b7bc3451(keymap);
    return;
}
function $9d680eb148465d1f$export$d69faf3b7bc3451(keymap) {
    const browser = (0, $jxkn6.getBrowserInfo)();
    if (browser.mac) return keymap.mac;
    return keymap.windows;
}
function $9d680eb148465d1f$export$6db28e5c399297b0(keymap) {
    let keyShortcuts;
    const browser = (0, $jxkn6.getBrowserInfo)();
    if (typeof keymap === 'string') keyShortcuts = keymap;
    else if (typeof keymap === 'object') keyShortcuts = keymap[browser.mac ? 'mac' : 'windows'];
    if (keyShortcuts) return keyShortcuts.toLowerCase().split('-').filter(Boolean).map((modifier)=>{
        switch(modifier){
            case 'cmd':
                return 'Meta';
            case 'ctrl':
                return 'Control';
            case 'alt':
                return 'Alt';
            case 'shift':
                return 'Shift';
            case 'enter':
                return 'Enter';
            case 'esc':
                return 'Esc';
            case 'tab':
                return 'Tab';
            case 'space':
                return 'Space';
            case 'backspace':
                return 'Backspace';
            case 'arrowup':
                return 'Arrow Up';
            case 'arrowdown':
                return 'Arrow Down';
            default:
                // eslint-disable-next-line @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
                return modifier.split('').join(' ');
        }
    }).join('+');
    else return undefined;
}
const $9d680eb148465d1f$var$ALL = [
    $9d680eb148465d1f$export$dca848a1b50b6a31,
    $9d680eb148465d1f$export$c0e115f47553645e,
    $9d680eb148465d1f$export$183fe6d20e9e58ba,
    $9d680eb148465d1f$export$b03177f345903916,
    $9d680eb148465d1f$export$6bcc93697958b66d,
    $9d680eb148465d1f$export$6d564ba4eaf138d9,
    $9d680eb148465d1f$export$d26ab98fee0c804,
    $9d680eb148465d1f$export$4af6b58e12324fd,
    $9d680eb148465d1f$export$70686c6e7e15ed46,
    $9d680eb148465d1f$export$63c4f0859cc75dc6,
    $9d680eb148465d1f$export$953ab0e6a5d310a9,
    $9d680eb148465d1f$export$192a351cfd6ca247,
    $9d680eb148465d1f$export$fe382f3f4c871c62,
    $9d680eb148465d1f$export$4073e08db19e0e31,
    $9d680eb148465d1f$export$b84e85b2035ddb39,
    $9d680eb148465d1f$export$86b1ac99fd15509b,
    $9d680eb148465d1f$export$16f43eb2b2380de5,
    $9d680eb148465d1f$export$34ed0cbd4f7ff88,
    $9d680eb148465d1f$export$c2d9390f63354627,
    $9d680eb148465d1f$export$5f13bbad564673d4,
    $9d680eb148465d1f$export$9e5a9569a07601f2,
    $9d680eb148465d1f$export$e920ee2eb756d384,
    $9d680eb148465d1f$export$1688e416fee0a49e,
    $9d680eb148465d1f$export$21f930c44940fd98,
    $9d680eb148465d1f$export$71aa6c912b956294,
    $9d680eb148465d1f$export$4e7f196112fea3c5,
    $9d680eb148465d1f$export$e668df1bcd81e4d2,
    $9d680eb148465d1f$export$9f99fe2ed5bb7a29
];
function $9d680eb148465d1f$export$d8a7f422d8d42038(description, windows, mac, common) {
    return {
        description: description,
        windows: windows.replace($9d680eb148465d1f$var$MOD_REGEX, 'Ctrl'),
        mac: mac.replace($9d680eb148465d1f$var$MOD_REGEX, 'Cmd'),
        common: common
    };
}
function $9d680eb148465d1f$export$7e6b588cc98b34f1(description, common) {
    const windows = common.replace($9d680eb148465d1f$var$MOD_REGEX, 'Ctrl');
    const mac = common.replace($9d680eb148465d1f$var$MOD_REGEX, 'Cmd');
    return $9d680eb148465d1f$export$d8a7f422d8d42038(description, windows, mac, common);
}
function $9d680eb148465d1f$export$5882c1dfa05eb556(description, shortcuts) {
    const keymapArray = [];
    shortcuts.forEach((shortcut)=>{
        keymapArray.push($9d680eb148465d1f$export$7e6b588cc98b34f1(description, shortcut));
    });
    return keymapArray;
}
function $9d680eb148465d1f$var$combineWithOldCommand(cmd, oldCmd) {
    return (state, dispatch, editorView)=>{
        return oldCmd(state, dispatch) || cmd(state, dispatch, editorView);
    };
}
function $9d680eb148465d1f$export$4bced0ac29aaf950(shortcut, cmd, keymap) {
    const oldCmd = keymap[shortcut];
    keymap[shortcut] = oldCmd ? $9d680eb148465d1f$var$combineWithOldCommand(cmd, oldCmd) : cmd;
}
function $9d680eb148465d1f$export$e40cfdbcfa26f180(shortcutsArray, cmd, keymap) {
    shortcutsArray.forEach((shortcut)=>{
        // Ignored via go/ees005
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return $9d680eb148465d1f$export$4bced0ac29aaf950(shortcut.common, cmd, keymap);
    });
}
function $9d680eb148465d1f$export$b87d3e1cb85f0ba1(shortcut, cmd, keymap) {
    $9d680eb148465d1f$export$4bced0ac29aaf950(shortcut, (0, $iPR6g.editorCommandToPMCommand)(cmd), keymap);
}
function $9d680eb148465d1f$export$b2dbe47650bcfa54(keyMap) {
    if (keyMap) {
        const browser = (0, $jxkn6.getBrowserInfo)();
        if (browser.mac) return keyMap.mac;
        return keyMap.windows;
    }
    return;
}
function $9d680eb148465d1f$export$f2da701c7659a26c(event) {
    let keyboardEvent = event;
    const name = (0, $kitud.keyName)(event);
    if (event.ctrlKey && event.getModifierState('CapsLock') && !event.getModifierState('Shift') && name.length === 1 && $9d680eb148465d1f$var$UPPERCASE_START_REGEX.test(name)) keyboardEvent = new KeyboardEvent('keydown', {
        key: (0, $kitud.base)[event.keyCode].toLowerCase(),
        code: event.code,
        ctrlKey: true
    });
    return keyboardEvent;
}

});


//# sourceMappingURL=shared.e2e46016.js.map
